import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType, ChartTitleOptions } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';

import { ReportingService } from '../../../../services/reporting.service';

import jspdf, { TextOptionsLight } from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable, { Styles } from 'jspdf-autotable';
import { Subject } from 'rxjs';
import { NetworkService } from '../../../../services/network.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { _ENDPOINT } from '../../../../endpoints/endpoint';
import { mapCountryDropdownItem, mapCountryDropdownItems } from '../../../../utility/country.util';

@Component({
  selector: 'app-sla-kpis',
  templateUrl: './sla-kpis.component.html',
  styleUrls: ['./sla-kpis.component.css']
})
export class SlaKpisComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() dropdownListBO: any[] = [];
  @Input() selectedItemsBO: any[] = [];
  @Input() dropdownListOrderCluster: any[] = [];
  @Input() selectedItemsOrderCluster: any[] = [];
  @Input() dropdownListCustomer: any[] = [];
  @Input() selectedItemsCustomer: any[] = [];
  @Input() dropdownListCountry: any[] = [];
  @Input() selectedItemsCountry: any[] = [];
  @Input() dropdownListMonth: any[] = [];
  @Input() selectedItemsMonth: any[] = [];
  @Input() dropdownListYear: any[] = [];
  @Input() selectedItemsYear: any[] = [];
  @Input() dropdownListOrderType: any[] = [];
  @Input() selectedItemsOrderType: any[] = [];
  @Input() customerOfCountry: Map<string, string[]>;
  @Input() orderTypeOfOrderCLuster: Map<string, string[]>;
  @Input() idLeadGlobalOfCustomerName: Map<string, string[]>;
  @Input() selectedItemsIdGlobal: any[] = [];

  @Input() dropdownListOrderStatus: any[] = [];
  @Input() selectedItemsOrderStatus: any[] = [];
  @Input() dropdownListLead: any[] = [];
  @Input() selectedItemsLead: any[] = [];


  @Output() loadReportEvent = new EventEmitter<any>();

  @Input() listAverage: any[] = []

  viewOrderStatus: boolean = false;
  viewMonth: boolean = true;

  public chart_Options: ChartOptions = {
    legend: {
      labels: {
        fontColor: "black",
        fontSize: 18
      }
    },
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          precision: 0
        }
      }]
    },
    plugins: {
      labels: false

    }
  };
  public chart_Labels: Label[] = ['1 Day', '1 Week', '2 Weeks'];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];

  @Input() chart_Data: ChartDataSets[] = [];

  @Input() pieChartLabels: Label[] = [];
  @Input() pieChartData: SingleDataSet = [];

  colors: Color[] = [
    {
      backgroundColor: [
        '#FE0000',
        '#66FF66',


      ]
    }
  ];

  colorsOnlyRespected: Color[] = [
    {
      backgroundColor: [
        '#66FF66',


      ]
    }
  ];

  colorsOnlyNot: Color[] = [
    {
      backgroundColor: [
        '#FE0000'


      ]
    }
  ];

  public pieChartOptions: ChartOptions = {
    title: {
      text: 'Orders "Completed" by SLA',
      display: true,
      position: 'top',
      fontSize: 18,
      fontStyle: 'bold',
      fontColor: "black"
    },
    legend: {
      labels: {
        fontColor: "black",
        fontSize: 18,
        fontStyle: 'bold'
      },
      onClick: (event, legendItem) => {
        event.stopPropagation();
      },
      reverse: true
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        fontSize: 14,
        position: 'outside',
        precision: '2',
        fontStyle: 'bold',
        textMargin: 10,
        outsidePadding: 4
      },

    }
  };
  @ViewChild('reportSlaKpis') pdfReport: ElementRef;

  responseTendineInventory: any = {};
  destroy$ = new Subject<boolean>();



  constructor(private reportingService: ReportingService, private networkService: NetworkService,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    if (!this.reportingService.slaKpisLoadedAlmostOneTime) {
      this.initTendineValue();
    } else {
      this.selectedItemsYear = this.reportingService.selectedItemsSlaKpis.selectedItemsYear;
      this.selectedItemsMonth = this.reportingService.selectedItemsSlaKpis.selectedItemsMonth;
      this.selectedItemsCountry = this.reportingService.selectedItemsSlaKpis.selectedItemsCountry;
      this.selectedItemsCustomer = this.reportingService.selectedItemsSlaKpis.selectedItemsCustomer;
      this.selectedItemsOrderType = this.reportingService.selectedItemsSlaKpis.selectedItemsOrderType;
      this.selectedItemsBO = this.reportingService.selectedItemsSlaKpis.selectedItemsBO;
      this.selectedItemsIdGlobal = this.reportingService.selectedItemsSlaKpis.selectedItemsIdGlobal;
      this.selectedItemsLead = this.reportingService.selectedItemsSlaKpis.selectedItemsLead;
      this.selectedItemsOrderStatus = this.reportingService.selectedItemsSlaKpis.selectedItemsOrderStatus;
      this.selectedItemsOrderCluster = this.reportingService.selectedItemsSlaKpis.selectedItemsOrderCluster;
      this.listAverage = this.reportingService.listAverageSlaKpi;
      this.pieChartData = this.reportingService.singleDataSetSlaKpi;
      this.pieChartLabels = this.reportingService.labelSlaKpi;
    }

  }

  initTendineValue() {
    this.initOrderCluster();
    this.initBO();
    this.initCountry();
    this.initCustomer();
    this.initMonth();
    this.initYear();
    this.initOrderType();
    this.initOrderStatus();
    this.initLead();
    this.initReport();
  }

  initOrderCluster() {
    let arrayOrderCluster: any[] = [];
    if (this.dropdownListOrderCluster && this.dropdownListOrderCluster.length > 0) {
      for (let elem of this.dropdownListOrderCluster) {
        arrayOrderCluster.push(elem);
      }
    }
    this.selectedItemsOrderCluster = arrayOrderCluster;
  }

  initBO() {
    let arrayBO: any[] = [];
    if (this.dropdownListBO && this.dropdownListBO.length > 0) {
      for (let elem of this.dropdownListBO) {
        arrayBO.push(elem);
      }
    }
    this.selectedItemsBO = arrayBO;
  }

  initCountry() {
    let arrayCountry: any[] = [];
    if (this.dropdownListCountry && this.dropdownListCountry.length > 0) {
      for (let elem of this.dropdownListCountry) {
        arrayCountry.push(elem);
      }
    }
    this.selectedItemsCountry = arrayCountry;
  }

  initCustomer() {
    let arrayCustomer: any[] = [];
    if (this.dropdownListCustomer && this.dropdownListCustomer.length > 0) {
      for (let elem of this.dropdownListCustomer) {
        arrayCustomer.push(elem);
      }
    }
    this.selectedItemsCustomer = arrayCustomer;
    this.initCustomerIdGlobal();
  }

  initMonth() {
    let arrayMonth: any[] = [];
    if (this.dropdownListMonth && this.dropdownListMonth.length > 0) {
      for (let elem of this.dropdownListMonth) {
        arrayMonth.push(elem);
      }
    }
    this.selectedItemsMonth = arrayMonth;
  }

  initYear() {
    let arrayYear: any[] = [];
    if (this.dropdownListYear && this.dropdownListYear.length > 0) {
      for (let elem of this.dropdownListYear) {
        if (elem.item_id == this.getCurrentYear()) {
          arrayYear.push(elem);
        }

      }
    }
    this.selectedItemsYear = arrayYear;
  }

  initOrderType() {
    let arrayOrderType: any[] = [];
    if (this.dropdownListOrderType && this.dropdownListOrderType.length > 0) {
      for (let elem of this.dropdownListOrderType) {
        arrayOrderType.push(elem);
      }
    }
    this.selectedItemsOrderType = arrayOrderType;
  }

  loadReport(data: any) {
    this.loadReportEvent.emit(data);
  }

  initReport() {
    let data: any = {
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster,
    };
    this.reportingService.setSelectedItemsSlaKpis(data);
    this.loadReportEvent.emit(data);
  }

  initCustomerIdGlobal() {
    let arrayIdGlobal: any[] = [];
    if (this.selectedItemsCustomer && this.selectedItemsCustomer.length > 0) {
      for (let elem of this.selectedItemsCustomer) {
        let key: string = elem.item_id;
        if (this.idLeadGlobalOfCustomerName) {
          let arrayIds = this.idLeadGlobalOfCustomerName.get(key);
          if (Array.isArray(arrayIds)) {
            for (let globalId of arrayIds) {
              let data: any = {
                item_id: globalId,
                item_text: globalId
              }
              let cust = arrayIdGlobal.find(x => x.item_id == data.item_id);
              if (!cust) {
                arrayIdGlobal.push(data);
              }

            }
          }
        }
      }
    }
    this.selectedItemsIdGlobal = arrayIdGlobal;
  }

  initOrderStatus() {
    let arrayOrderStatus: any[] = [];
    if (this.dropdownListOrderStatus && this.dropdownListOrderStatus.length > 0) {
      for (let elem of this.dropdownListOrderStatus) {
        if (elem.item_id == "COMPLETED") {
          arrayOrderStatus.push(elem);
        }
      }
    }
    this.selectedItemsOrderStatus = arrayOrderStatus;
  }

  initLead() {
    let arrayLead: any[] = [];
    if (this.dropdownListLead && this.dropdownListLead.length > 0) {
      for (let elem of this.dropdownListLead) {
        arrayLead.push(elem);
      }
    }
    this.selectedItemsLead = arrayLead;
  }

  updateFilterEvent(event: any) {
    this.selectedItemsYear = event.selectedItemsYear;
    this.selectedItemsMonth = event.selectedItemsMonth;
    this.selectedItemsCountry = event.selectedItemsCountry;
    this.selectedItemsCustomer = event.selectedItemsCustomer;
    this.selectedItemsOrderType = event.selectedItemsOrderType;
    this.selectedItemsBO = event.selectedItemsBO;
    this.selectedItemsIdGlobal = event.selectedItemsIdGlobal;
    this.selectedItemsLead = event.selectedItemsLead;
    this.selectedItemsOrderStatus = event.selectedItemsOrderStatus;
    this.selectedItemsOrderCluster = event.selectedItemsOrderCluster;
    this.reportingService.setChangedFilterSlaKpis();
    this.reportingService.setSelectedItemsSlaKpis(event);
  }

  getCurrentYear(): string {
    const currentYear = new Date().getFullYear();
    return String(currentYear);
  }

  viewSlaKpi() {
    if (this.pieChartData && this.pieChartData.length > 0 && this.pieChartData.length==2) {
      return true;
    } else {
      return false;
    }
  }

  viewSlaKpiOnlyRespected() {
    if (this.pieChartData && this.pieChartData.length > 0 && this.pieChartData.length==1 && this.pieChartLabels && this.pieChartLabels.length==1 && this.pieChartLabels[0]=="SLA respected") {
      return true;
    } else {
      return false;
    }
  }

  viewSlaKpiOnlyNotRespected() {
    if (this.pieChartData && this.pieChartData.length > 0 && this.pieChartData.length==1 && this.pieChartLabels && this.pieChartLabels.length==1 && this.pieChartLabels[0]=="SLA not respected") {
      return true;
    } else {
      return false;
    }
  }

  htmltoPDF() {
    // printDiv is the html element which has to be converted to PDF
    const pdfTable = this.pdfReport.nativeElement;
    html2canvas(pdfTable).then(canvas => {
      const width = 208;
      var height = canvas.height * width / canvas.width;
      var imgData = canvas.toDataURL('image/png');
      var pdf = new jspdf('l', 'mm', 'a4');
      pdf.setFont('gill-sans-nova');
      let widthImage = pdf.internal.pageSize.getWidth();
      let heightImage = pdf.internal.pageSize.getHeight();
      let cont: number = 15;
      let options: TextOptionsLight = {
        align: 'center'
      };
      pdf.setFontSize(20);
      pdf.text("SLA Metrics Report", widthImage/2, cont, options);
      pdf.setFontSize(16);
      let orderClusterString: string = this.createTextBySelectedItems(this.selectedItemsOrderCluster);

      let leadmember: string = this.createTextBySelectedItems(this.selectedItemsLead);

      let customers: string = this.createTextBySelectedItems(this.selectedItemsCustomer);

      let bmember: string = this.createTextBySelectedItems(this.selectedItemsBO);

      let nazioni: string = this.createTextBySelectedItems(this.selectedItemsCountry);

      let years: string = this.createTextBySelectedItems(this.selectedItemsYear);

      let mesi: string = this.createTextBySelectedItems(this.selectedItemsMonth);

      let tipi: string = this.createTextBySelectedItems(this.selectedItemsOrderType);

      let orderStatus: string = this.createTextBySelectedItems(this.selectedItemsOrderStatus);

      pdf.addImage(imgData, 'PNG', 2, heightImage/4, widthImage-6, height+20);
      pdf.addPage();

      pdf.text("SLA Metrics Filters", widthImage/2, cont, options);

      let styles: Partial<Styles> = {
        font: 'gill-sans-nova'
      };

      autoTable(pdf, {
        head: [['FILTER', 'VALUES']],
        body: [
          ['YEAR', years],
          ['MONTH', mesi],
          ['ORDER CLUSTER', orderClusterString],
          ['LEAD OPERATOR', leadmember],
          ['CUSTOMER', customers],
          ['B OPERATOR', bmember],
          ['COUNTRY', nazioni],
          ['ORDER TYPE', tipi],
          ['ORDER STATUS', orderStatus],
        ],
        startY:  30,
        styles: styles
      });





      pdf.save("SLAMetricsReport.pdf");

    });

  }



  viexExportPdf() {
    if (this.pieChartData && this.pieChartData.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  createTextBySelectedItems(selectedItem: any[]) {
    let result: string = "";
    if (selectedItem && selectedItem.length > 0) {
      let i: number = 1;
      for (let elem of selectedItem) {

        if (i == selectedItem.length) {
          result = result + (elem.item_text || elem.item_id);
        } else {
          result = result + (elem.item_text || elem.item_id) + " , "
        }
        i++;

      }

    }
    return result;
  }

  getSumCompleted() {
    let sum = 0;
    if (this.listAverage && this.listAverage.length > 0) {
      for (let elem of this.listAverage) {
        if (elem.orderStatus == "COMPLETED") {
          return elem.average;
        }
      }
    }
    return sum;
  }

  getSumFailed() {
    let sum = 0;
    if (this.listAverage && this.listAverage.length > 0) {
      for (let elem of this.listAverage) {
        if (elem.orderStatus == "FAILED") {
          return elem.average;
        }
      }
    }
    return sum;
  }

  getSumProgress() {
    let sum = 0;
    if (this.listAverage && this.listAverage.length > 0) {
      for (let elem of this.listAverage) {
        if (elem.orderStatus == "INPROGRESS") {
          return elem.average;
        }
      }
    }
    return sum;
  }





  ngAfterViewInit(): void {

    this.pdfReport.nativeElement.focus();

  }

  initializeTendine() {

    this.spinner.show("sp1");
    let urlTendineReporting: string = environment.basePath + _ENDPOINT.getTendineReporting;
    let data = {
      body: ''
    }
    this.networkService.post(urlTendineReporting, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseTendineInventory = JSON.parse(response.body);
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.customerOfCountry) {
            this.responseTendineInventory = response;
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  initTendineCountryAndCustomer(responseTendineInventory: any) {
    if (responseTendineInventory && responseTendineInventory.customerOfCountry
      && responseTendineInventory.orderTypeOfOrderCLuster) {
      this.customerOfCountry = new Map(Object.entries(responseTendineInventory.customerOfCountry));
      this.orderTypeOfOrderCLuster = new Map(Object.entries(responseTendineInventory.orderTypeOfOrderCLuster));
      this.idLeadGlobalOfCustomerName = new Map(Object.entries(responseTendineInventory.idLeadGlobalOfCustomerName));
      this.initDropdownCountryCustomer();
    }
  }

  initDropdownCountryCustomer() {
    let country: any[] = [];
    let customer: any[] = [];
    for (let [key, value] of this.customerOfCountry) {
      let data = mapCountryDropdownItem({ item_id: key, item_text: key });
      if (country.indexOf(data) == -1) {
        country.push(data);
      }
      for (let elem of value) {
        let dataCustomer = { item_id: elem, item_text: elem };
        let cust = customer.find(x => x.item_id == dataCustomer.item_id);
        if (!cust) {
          customer.push(dataCustomer);
        }

      }
    }
    this.dropdownListCountry = mapCountryDropdownItems(country);
    this.dropdownListCustomer = customer;
  }

  initTendine(responseTendineInventory: any) {
    this.dropdownListBO = responseTendineInventory.dropdownListBO;
    this.dropdownListOrderCluster = responseTendineInventory.dropdownListOrderCluster;
    this.dropdownListMonth = responseTendineInventory.dropdownListMonth;
    this.dropdownListYear = responseTendineInventory.dropdownListYear;
    this.dropdownListOrderType = responseTendineInventory.dropdownListOrderType;
    this.dropdownListOrderStatus = responseTendineInventory.dropdownListOrderStatus;
    this.dropdownListLead = responseTendineInventory.dropdownListLead;
    this.initTendineValue();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
